/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Search_PlaceholderInputs */

const cs_demands_search_placeholder = /** @type {(inputs: Demands_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient nebo název poptávky`)
};

const en_demands_search_placeholder = /** @type {(inputs: Demands_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client or demand name`)
};

/**
* | output |
* | --- |
* | "Client or demand name" |
*
* @param {Demands_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_search_placeholder = /** @type {((inputs?: Demands_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_search_placeholder(inputs)
	return cs_demands_search_placeholder(inputs)
});